import { render, staticRenderFns } from "./AdminAnnouncements.vue?vue&type=template&id=0b439e06&scoped=true"
import script from "./AdminAnnouncements.vue?vue&type=script&lang=js"
export * from "./AdminAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./AdminAnnouncements.vue?vue&type=style&index=0&id=0b439e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b439e06",
  null
  
)

export default component.exports